import { http } from "../utils/http";

/**
 * Доступы — правка №11 (Чат 5). [Claude] 2026-11-02
 * Роли и права MR !11 (/compliance/*) + экран доступа (/compliance/access/*).
 * subject — ERP id человека или «emp:<id сотрудника>» для тех, у кого нет ERP.
 */
const enc = (s) => encodeURIComponent(String(s));

export const getAccessMe = () => http.get("/compliance/me");
export const getAccessPeople = () => http.get("/compliance/access/people");
export const getAccessSubject = (subject) => http.get(`/compliance/access/subject/${enc(subject)}`);
export const saveAccessOverrides = (subject, { allow, deny, comment }) =>
    http.put(`/compliance/access/subject/${enc(subject)}/overrides`, { allow, deny, comment });
export const blockAccess = (subject) => http.post(`/compliance/users/${enc(subject)}/block`, {});
export const unblockAccess = (subject) => http.post(`/compliance/access/subject/${enc(subject)}/unblock`, {});
// Правка №58: служебные учётки и роль по умолчанию.
export const setServiceAccount = (employeeId, { hidden, reason }) =>
    http.put(`/compliance/access/service-accounts/${enc(employeeId)}`, { hidden, reason });
export const saveDefaultRole = (role) =>
    http.put("/compliance/settings/rbac.default_role", { value: { role }, comment: "Роль по умолчанию" });
// Правка №34: «Поделиться адаптацией» — человек видит ход конкретной адаптации, даже если по роли не видит.
export const getAdaptationShares = (subject) => http.get(`/compliance/access/adaptation-shares?subject=${enc(subject)}`);
export const getOpenAdaptations = () => http.get("/compliance/access/adaptation-enrollments");
export const addAdaptationShare = ({ subject, enrollment_id, until, comment }) =>
    http.post("/compliance/access/adaptation-shares", { subject, enrollment_id, until: until || null, comment: comment || null });
export const removeAdaptationShare = (id) => http.del(`/compliance/access/adaptation-shares/${enc(id)}`);
export const getAccessLog = (limit = 200) => http.get(`/compliance/access/log?limit=${limit}`);

export const getRoles = () => http.get("/compliance/roles");
export const saveRole = (key, { name, description, grants }) =>
    http.put(`/compliance/roles/${enc(key)}`, { name, description, grants });
export const archiveRole = (key) => http.del(`/compliance/roles/${enc(key)}`);
export const assignRole = (subject, { role_key, user_name, department }) =>
    http.post(`/compliance/users/${enc(subject)}/roles`, { role_key, user_name, department });
export const unassignRole = (subject, roleKey) => http.del(`/compliance/users/${enc(subject)}/roles/${enc(roleKey)}`);

export const getFlags = () => http.get("/compliance/flags");
export const saveFlag = (key, { state, pilot_user_ids }) =>
    http.put(`/compliance/flags/${enc(key)}`, { state, pilot_user_ids });
